// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__k7jy0","modalFooterButton":"ModalNotes_modalFooterButton__1qfBN"};